import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import TitlePage from "./TitlePage";
import Survey from "./survey";
import MemoryGame from "./MemoryGame";
import EndSurvey from "./EndSurvey";
import "./App.css";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<TitlePage />} />
        <Route path="/survey" element={<Survey />} />
        <Route path="/memory" element={<MemoryGame />} />
        <Route path="/endsurvey" element={<EndSurvey />} />
      </Routes>
    </Router>
  );
}

export default App;